<div class="propero-fiscal">
  <!-- Hero -->
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'FISCAL_GUIDE.HERO_EYEBROW' | translate }}
      </div>

      <h1 class="ph-hero__title">{{ 'FISCAL_GUIDE.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'FISCAL_GUIDE.SUBTITLE' | translate }}</p>

      <div class="ph-hero__actions ph-hero__actions--centered">
        <a routerLink="/calculator4" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'FISCAL_GUIDE.TOOL_CALC_CTA' | translate }}
        </a>
        <a routerLink="/documents" class="ph-btn ph-btn--outline ph-btn--lg">
          {{ 'FISCAL_GUIDE.TOOL_DOCS_CTA' | translate }}
        </a>
      </div>
    </div>
  </section>

  <!-- Checklist topics -->
  <section id="topics" class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FISCAL_GUIDE.TOPICS_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'FISCAL_GUIDE.TOPICS_LEAD' | translate }}</p>
      </div>

      <div class="ph-faq">
        <div *ngFor="let index of topicIndexes; let i = index" class="ph-faq__item">
          <button
            type="button"
            class="ph-faq__trigger"
            (click)="toggleTopic(i)"
            [attr.aria-expanded]="openTopicIndex === i">
            <span class="ph-faq__step">{{ index }}</span>
            <span class="ph-faq__question">{{ topicTitleKey(index) | translate }}</span>
            <i class="lni lni-chevron-down ph-faq__chevron" [class.ph-faq__chevron--open]="openTopicIndex === i"></i>
          </button>
          <div class="ph-faq__panel" *ngIf="openTopicIndex === i">
            <p>{{ topicTextKey(index) | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Tax summary -->
  <section id="tax" class="ph-section">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FISCAL_GUIDE.TAX_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'FISCAL_GUIDE.TAX_LEAD' | translate }}</p>
      </div>

      <div class="ph-tax-grid">
        <article *ngFor="let index of taxIndexes" class="ph-tax-card">
          <div class="ph-tax-card__icon" aria-hidden="true">
            <i class="lni lni-checkmark-circle"></i>
          </div>
          <h3 class="ph-tax-card__title">{{ taxTitleKey(index) | translate }}</h3>
          <p class="ph-tax-card__text">{{ taxTextKey(index) | translate }}</p>
        </article>
      </div>

      <p class="ph-disclaimer">{{ 'FISCAL_GUIDE.DISCLAIMER' | translate }}</p>
    </div>
  </section>

  <!-- Tools -->
  <section id="tools" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FISCAL_GUIDE.TOOLS_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'FISCAL_GUIDE.TOOLS_LEAD' | translate }}</p>
      </div>

      <div class="ph-tools__grid">
        <a routerLink="/calculator4" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni lni-calculator"></i></div>
          <h3 class="ph-tool-card__title">{{ 'FISCAL_GUIDE.TOOL_CALC_TITLE' | translate }}</h3>
          <p class="ph-tool-card__text">{{ 'FISCAL_GUIDE.TOOL_CALC_TEXT' | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'FISCAL_GUIDE.TOOL_CALC_CTA' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>

        <a routerLink="/documents" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni lni-files"></i></div>
          <h3 class="ph-tool-card__title">{{ 'FISCAL_GUIDE.TOOL_DOCS_TITLE' | translate }}</h3>
          <p class="ph-tool-card__text">{{ 'FISCAL_GUIDE.TOOL_DOCS_TEXT' | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'FISCAL_GUIDE.TOOL_DOCS_CTA' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>

        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni lni-dashboard"></i></div>
          <h3 class="ph-tool-card__title">Propero Assistant</h3>
          <p class="ph-tool-card__text">{{ 'HOME.FISCAL_GUIDE_TEXT_SHORT' | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'SOLUTION_GENERAL.CREATE_ACCOUNT' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>
</div>
